import createReducer from '../../utils/createReducer';
import actions from './actions';

const actionHandlers = {};
export const initialState = {
    cardIndex: 0,
    numCardsVisible: 0,
    isInView: false
};

actionHandlers[actions.CHANGE_CARD_INDEX] = (state, {payload: {cardIndex}}) => {
    return {
        ...state,
        cardIndex
    };
};

actionHandlers[actions.CHANGE_NUM_CARDS_VISIBLE] = (state, {payload: {numCardsVisible}}) => {
    return {
        ...state,
        numCardsVisible
    };
};

actionHandlers[actions.SCROLLED_INTO_VIEW] = (state) => {
    return {
        ...state,
        isInView: true
    };
};

export default createReducer(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/universal/tripboard/recommended-properties/reducer-recommended-properties.js